
















import SmallText from "@/common/components/atoms/SmallText.vue";
import Component from "vue-class-component";
import { Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
    SmallText
  }
})
export default class JUserSelectPanelBody extends Vue {
  @Prop({ type: Object, default: {} }) detailData!: any;

  get name() {
    return this.detailData.name;
  }

  get id() {
    return this.detailData.id;
  }

  get usingEmployeeId() {
    return this.detailData.usingEmployeeId;
  }

  get groupName() {
    return this.detailData.groupName;
  }

  get smallTextColor() {
    const isSp = this.$store.state.isLargeBreakpointWidthOfSp;
    const smallTextCustomColor = "#333333";
    return isSp ? "" : smallTextCustomColor;
  }
}
